import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
    DatePicker, 
    TimePicker, 
    Progress,
    message,
} from 'antd'
import { firestore, firStorage } from '../../../service/firebase'
import './CalendarEvent.scss'
import moment from 'moment'
import EventService from '../../../service/event';

const { TextArea } = Input


export default class CalendarEvent extends React.Component {
    
    columns = [
        { title: 'Order', dataIndex: '', key: 'order', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleUp(item)}>UP</a>
                    <Divider type="vertical" />
                    <a onClick={() => this.handleShowOrder(item)}>{item['sort']}</a>
                    <Divider type="vertical" />
                    <a onClick={() => this.handleDown(item)}>DOWN</a>
                </span>
            )
        }},
        { title: "Title / Address", dataIndex: '', key: 'title', render: (data) => {
            return (
                <div>
                    <div style={{fontWeight: 'bold'}}>{data['title']}</div>
                    <div style={{fontSize: 12}}>{data['address']}</div>
                </div>
            )
        }},
        { title: "Start / End", dataIndex: '', key: 'start', render: (data) => {
            return (
                <div>
                    <div>{this.dateDetail(data['start'])}</div>
                    <div>{this.dateDetail(data['end'])}</div>
                </div>
            )
        }},
        { title: "Logo", dataIndex: 'logo', key: 'logo', render: logo => {
            return <img src={logo} style={{maxWidth: 50, maxHeight: 50}} alt="IMG-LOGO" />
        } },
        { title: 'Actions', dataIndex: '', key: 'action', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleEdit(item)}>Edit</a>
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []
    
    state = {
        showModal: false,
        showOrder: false,
        uploadState: 0,
        downloadURL: '',
        order: 0,
        orderError: '',
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('Events')
        .orderBy("sort")
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    dateFormat(date) {
        let year = this.numberFormat(date.getFullYear())
        let month = this.numberFormat(date.getMonth() + 1)
        let day = this.numberFormat(date.getDate())
        let hr = this.numberFormat(date.getHours())
        let min = this.numberFormat(date.getMinutes())

        return year + '/' + month + '/' + day + ' ' + hr + ':' + min
    }

    numberFormat(num) {
        return num > 9 ? num + '' : '0' + num
    }

    dateDetail(date) {
        if(date) {
            let dateStr = this.dateFormat(date.toDate())
            return (<div>{dateStr}</div>)
        } else {
            return (<div> - </div>)
        }
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            title: '',
            description: '',
            address: '',
            location: '',
            id: '',
            logo: null,
            startDate: null,
            startTime: null,
            endDate: null,
            endTime: null,
            showModal: true,
            uploadState: 0,
        })
    }

    updateSort() {
        // Save event to the firebase..
        this.dataList.forEach(data => {
            let info = { sort: data['sort'] }
            firestore.collection('Events').doc(data['id']).update(info)
            console.log("Data", info, data)
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        let state = this.state


        let start = item.start ? moment(item.start.toDate()).format('YYYY-MM-DDTHH:mm:ss') : null
        let end = item.end ? moment(item.end.toDate()).format('YYYY-MM-DDTHH:mm:ss') : null
        console.log(item.start)
        let startTime = start.substring(10, 18)
        let endTime = end.substring(10, 18)

        let added = {}

        if(start) {
            added = Object.assign(added, {
                startDate: moment(start, 'YYYY-MM-DD'),
                startTime: moment(startTime, 'HH:mm:ss'),
            })
        }

        if(end) {
            added = Object.assign(added, {
                endDate: moment(end, 'YYYY-MM-DD'),
                endTime: moment(endTime, 'HH:mm:ss'),
            })
        }

        let newState = Object.assign(state, item, added, {
            showModal: true,
            uploadState: 2, 
        })

        console.log(newState)
        this.setState(newState)
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('Events').doc(item.id).delete();
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('Events').doc()
            id = ref.id
        } else {
            ref = firestore.collection('Events').doc(id)
        }

        let start = this.dateFor(state.startDate, state.startTime)
        let end = this.dateFor(state.endDate, state.endTime)

        let object = {
            id,
            title: state.title ? state.title : '',
            description: state.description ? state.description : '',
            address: state.address ? state.address : '',
            location: state.location ? state.location : '',
            logo: state.logo ? state.logo : '',
            start,
            end,
            sort: this.dataList.length,
        }

        ref.set(object).then(() => {
            console.log("Saved New Event")
            let content = `${object.title} : ${object.description}`
            console.log("Content", content)
            EventService.notification("New Event Arrived", content);
        })
        this.setState({showModal: false})
    }

    dateFor(date, time) {

        if(!date || !time) return null

        let dateStr = date.format('YYYY-MM-DD')
        let timeStr = time.format('HH:mm:ss')

        return new Date(dateStr + 'T' + timeStr + '.000')
    }

    handleCloseModal() {
        this.setState({showModal: false})
    }

    handleShowOrder(item) {
        this.orderItem = item
        this.setState({
            order: item.sort,
            showOrder: true,
            orderError: '',
        })
    }

    handleCloseOrder() {
        this.setState({showOrder: false})
    }

    handleUpdateOrder() {
        let order = Number(this.state.order)

        if(isNaN(order)) {
            this.setState({orderError: 'Please input number as order!'})
            return
        }

        if(order < 1) order = 1
        if(order > this.dataList.length) order = this.dataList.length

        this.setState({showOrder: false})

        this.dataList.splice(Number(this.orderItem.sort) - 1, 1)
        this.dataList.splice(order - 1, 0, this.orderItem)

        let start = Number(this.orderItem.sort) > order ? order : Number(this.orderItem.sort)
        let end = Number(this.orderItem.sort) <= order ? order : Number(this.orderItem.sort)

        for(let i = start - 1; i < end; i++) {
            let item = this.dataList[i]
            firestore.collection('Events').doc(item.id).update({sort: i + 1})
        }
    }

    handleUp(item) {
        let index = Number(item.sort) - 1

        if(index <= 0) return

        this.dataList.splice(index, 1)
        this.dataList.splice(index - 1, 0, item)

        firestore.collection('Events').doc(item.id).update({sort: index})
        firestore.collection('Events').doc(this.dataList[index].id).update({sort: index + 1})
    }

    handleDown(item) {
        let index = Number(item.sort) - 1

        if(index >= this.dataList - 1) return

        this.dataList.splice(index, 1)
        this.dataList.splice(index + 1, 0, item)

        firestore.collection('Events').doc(item.id).update({sort: index + 2})
        firestore.collection('Events').doc(this.dataList[index].id).update({sort: index + 1})
    }

    /*-----------------Upload Image-------------------*/

    handleUpload(input) {
        input.click();
    }

    onChangeFile(evt, type) {
        let orgName = evt.target.files[0].name;
        let key = Date.now();
        let fileName = this.page + "_" + key + "." + orgName.substring(orgName.length - 3);
        let path = '/' + this.page + '/' + fileName;
        this.uploadFile(evt.target.files[0], path, type);
    }
    
    uploadFile(file, path, type) {
        if(this.state.uploadState === 1) {
            return;
        }

        this.setState({uploadState: 1});

        var uploadTask = firStorage.ref().child(path).put(file);
        uploadTask.on('state_changed', (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({uploadProgress: progress});
            console.log('Upload is ' + progress + '% done');
        }, (error) => {
            this.setState({uploadState: 0});
            message.error("Failed on uploading image! Try again please!");
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL);
                this.setState({
                    uploadState: 2,
                    logo: downloadURL
                });
            });
        });
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/

    renderCellDetail(row) {
        console.log(row)

        return(
            <Row className="cell">
                <div className="img">
                    <img src={row.logo} alt="IMG-LOGO" />
                </div>

                <div className="content">
                    <div className="content-row"><div className="caption"><b>Order :</b></div>{row.sort}</div>
                    <div className="content-row"><div className="caption"><b>Title :</b></div>{row.title}</div>
                    <div className="content-row"><div className="caption"><b>Address :</b></div>{row.address}</div>
                    <div className="content-row"><div className="caption"><b>Start Time :</b></div> {this.dateDetail(row.start)}</div>
                    <div className="content-row"><div className="caption"><b>End Time :</b></div> {this.dateDetail(row.end)}</div>
                    <div style={{margin: '20px 5px 5px 5px', display: 'flex'}}><div className="caption"><b>Description :</b></div></div>
                    <div style={{margin: 5, marginLeft: 100}}>{row.description}</div>
                </div>
            </Row>
        )
    }

    
    render() {

        return (
            <div className="calendar-event">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Event</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    expandedRowRender={record => this.renderCellDetail(record)} 
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                <Modal
                    title='Change Order'
                    visible={this.state.showOrder}
                    onOk={() => this.handleUpdateOrder()}
                    onCancel={() => this.handleCloseOrder()}>

                    <Row className="input-row">
                        <div className="input-label">Order To Update</div>
                        <Input value={this.state.order} onChange={evt => this.handleChange('order', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="error">{this.state.orderError}</div>
                    </Row>

                </Modal>

                <Modal
                    title={this.eventEdit ? 'Edit event' : "Add event"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleCloseModal()}>

                    <Row className="input-row">
                        <div className="input-label">Title</div>
                        <Input value={this.state.title} onChange={evt => this.handleChange('title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Address</div>
                        <Input value={this.state.address} onChange={evt => this.handleChange('address', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Location</div>
                        <Input value={this.state.location} onChange={evt => this.handleChange('location', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Start Event</div>
                        <DatePicker defaultValue={this.state.startDate} onChange={date => this.handleChange('startDate', date)} />
                        {
                            this.state.showModal &&
                            <TimePicker defaultValue={this.state.startTime} style={{marginLeft: 10}} onChange={time => this.handleChange('startTime', time)} />
                        }
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">End Event</div>
                        <DatePicker defaultValue={this.state.endDate} onChange={date => this.handleChange('endDate', date)} />
                        {
                            this.state.showModal &&
                            <TimePicker defaultValue={this.state.endTime} style={{marginLeft: 10}} onChange={time => this.handleChange('endTime', time)} />
                        }
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Description</div>
                        <TextArea autosize={{minRows: 3, maxRows: 9}} value={this.state.description} onChange={evt => this.handleChange('description', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Logo Image</div>
                        <div style={{cursor: 'pointer'}} onClick={() => this.handleUpload(this.logoInput)}>
                        {
                            this.state.uploadState === 0 ?
                                <div className="logo-placeholder">Logo</div> :
                            this.state.uploadState === 1 ?
                                <div style={{margin: 20}}>
                                    <Progress type="circle" percent={this.state.uploadProgress ? Number(this.state.uploadProgress.toFixed(2)) : 0} />
                                </div> :
                                <div className="logo-img">
                                    <img src={this.state.logo} alt="IMG-LOGO" />
                                </div>
                        }
                        </div>
                    
                        <input type="file" className="file-input"
                            ref={input => this.logoInput = input}
                            onChange={evt => this.onChangeFile(evt)}
                            accept="image/x-png,image/gif,image/jpeg" />

                    </Row>

                </Modal>

            </div>
        )
    }
}
